__turbopack_context__.v({
  "payment": "Checkout-module-scss-module__Q4MpFq__payment",
  "paymentBorder": "Checkout-module-scss-module__Q4MpFq__paymentBorder",
  "paymentOptions": "Checkout-module-scss-module__Q4MpFq__paymentOptions",
});
